
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getOrderInfo, orderCollectionLog } from '@/api/order/deposit'
import { orderNotify, editOrderAttach } from '@/api/order/notify'
import { jsonToObjArr } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { notifiedStatus, upStreamStatusList } from '@/utils/constant'
import PicsUploader from '@/components/PicsUploader/index.vue'
import { copyImgs } from '@/utils/clipboard'

@Component({
  name: 'depositDetail',
  components: {
    PicsUploader,
  },
})
export default class extends Vue {
  @Prop({ required: true }) ordernumber!: number
  get language() {
    return AppModule.language
  }
  private info: any = {}
  private orderLog: any = []
  private tabName: string = 'orderInformation'
  private subTabName: string = 'Upstream'
  private loading: boolean = false

  private upstream_notify: any[] = []
  private upstream_request: any[] = []
  private upstream_response: any[] = []
  private notify_request: any[] = []
  private downstream_request: any[] = []
  private notify_response: any[] = []
  private notify_time: any[] = []
  private activeNames: any = ['1']
  private orderTypeList = upStreamStatusList
  private notifiedStatus = notifiedStatus
  private setForm: any = {
    attach: [],
  }
  private attachVisible = false

  private copyImg(item: string) {
    copyImgs(item)
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  // 编辑 attach 弹窗
  private attachId: any = ''
  private attachUrl: any = []
  private attachEdit() {
    this.attachVisible = true
    this.attachId = this.ordernumber
    this.attachUrl = this.info.attach
  }

  // 编辑 attach
  private async editAttach() {
    try {
      this.loading = true
      let data: any = {
        ordernumber: this.attachId,
        attach: this.setForm.attach,
      }
      await editOrderAttach(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message.success('Edit success')
        }
        if (this.language === 'zh_cn') {
          this.$message.success('编辑成功')
        }
        if (this.language === 'zh_tw') {
          this.$message.success('編輯成功')
        }
        this.getOrderInfo()
        this.loading = false
        this.attachVisible = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private async notify(ordernumber: number) {
    await orderNotify({ ordernumber: ordernumber }).then(() => {
      this.$message({
        message: 'Notify successfully!',
        type: 'success',
      })
    })
  }

  private async getOrderInfo() {
    const data: any = {
      ordernumber: this.ordernumber,
    }
    await getOrderInfo(data).then((res: any) => {
      this.info = res
      console.log(this.info, 'this.info')
      this.upstream_notify = jsonToObjArr(res.upstream_notify)
      this.upstream_request = jsonToObjArr(res.upstream_request)
      this.upstream_response = jsonToObjArr(res.upstream_response)
      this.downstream_request = jsonToObjArr(res.downstream_request)
      this.notify_request = jsonToObjArr(res.notify_request)
      this.notify_response = jsonToObjArr(res.notify_response)
      this.notify_time = jsonToObjArr(res.notify_time)
    })
  }
  // 订单归集日志列表
  private async getOrderCollectionLog() {
    await orderCollectionLog(this.ordernumber).then((res: any) => {
      this.orderLog = res
    })
  }

  // 查看错误信息
  private errorInfo: any = {}
  private errorVisible: boolean = false
  private errorView(row) {
    this.errorInfo = row
    this.errorVisible = true
  }
  private closeError() {
    this.errorVisible = false
  }

  // 查看上游数据
  private upstreamInfo: any = {}
  private upstreamVisible: boolean = false
  private upstreamView(row) {
    this.upstreamInfo = row
    this.upstreamVisible = true
  }
  private closeUpstream() {
    this.upstreamVisible = false
  }

  private dataInfo: any = []
  private dataVisible: boolean = false
  private openDrawer(row) {
    this.dataInfo = jsonToObjArr(row)
    this.dataVisible = true
  }
  private closeData() {
    this.dataVisible = false
  }

  mounted() {
    this.getOrderInfo()
    this.getOrderCollectionLog()
  }
  created() {}
}
